import type { KAPLAYCtx } from '../types.ts'

import { useFloor08 } from './floor-08.ts'
import { useFloor09 } from './floor-09.ts'
import { useFloor10 } from './floor-10.ts'
import { useFloor11 } from './floor-11.ts'
import { useFloor12 } from './floor-12.ts'
import { useFloor13 } from './floor-13.ts'

export function useFloors(k: KAPLAYCtx) {
  const { setFloor08 } = useFloor08(k)
  const { setFloor09 } = useFloor09(k)
  const { setFloor10 } = useFloor10(k)
  const { setFloor11 } = useFloor11(k)
  const { setFloor12 } = useFloor12(k)
  const { setFloor13 } = useFloor13(k)

  return {
    setFloor08,
    setFloor09,
    setFloor10,
    setFloor11,
    setFloor12,
    setFloor13,
  }
}
